module.exports = __webpack_public_path__ + "static/media/chess.35943e7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/chess.svg
// module id = 368
// module chunks = 7